export default {
  // Filtros y configuracion de widgets (opciones de KPI)
  form_filter: 'Seleccione un formulario como filtro para este reporte',
  forms: 'Formularios',
  add_value: 'Agregar Valores',
  ungrouped: 'Sin Agrupar',
  add_meta: 'Agregar meta',
  meta: 'Meta',
  show_value: 'Mostrar etiquetas de valores',
  color: 'Colores',
  custom_scale: 'Colores personalizados',
  resulttype: 'Tipo de Resultado',
  groupby: 'Agrupar por',
  addfilter: 'Agregar Filtro',
  show_legend: 'Mostrar etiquetas',
  order_results: 'Ordenar resultados',
  fullfillment_options: 'Cumplimiento / Ejecuciones',
  type: 'Tipo:',
  expired_soon_options: 'Unidades / Importe',

  // Rangos de tiempo y tendencias
  tendencias: 'Tendencias',
  historic_3: 'Historico (trimestres)',
  historic_12: 'Histórico (12 meses)',
  historic_6: 'Histórico (6 meses)',
  historic_30: 'Histórico (30 días)',
  current_month: 'Mes en curso',
  thirty_days: 'Ultimos 30 días',
  seven_days: 'Ultimos 7 días',
  filter: 'Filtros',
  time: 'Tiempo',

  // Estados y mensajes genericos de widget
  load_details: 'Cargando detalles...',
  goal: 'Meta',
  kpi: 'KPI:',
  expiration: 'Widget Productos Caducados y Próximos a Caducar',
  widget_information: 'Se muestra toda la información sin filtrar (de acuerdo a sus roles).',
  stale_warning: 'No se pudo actualizar. Mostrando el último dato disponible',
  no_data: 'Sin datos para mostrar.',
  see_grafic: 'Ver gráfico',
  see_table: 'Ver Tabla',

  // Widget de ubicaciones
  ubication_top: 'Top de Ubicaciones',
  no_ubication: 'Sin Ubicación',

  // Widget de tareas
  total_task: 'Tareas totales',
  tasks: 'Tareas',
  no_result: 'No se encontraron resultados',

  // Widget de sprint y autoevaluacion
  no_usersprint: 'El usuario no se encuentra asignado a ningún sprint',
  search_users: 'Buscar usuario',
  sprint: 'Sprint',
  self_assessment: 'Autoevaluación',

  // Widget de reportes
  data_report: 'Contenido del reporte',
  report: 'Reporte',

  // Widget de planes de accion
  create_plans: 'Planes de accion creados',
  qualification: 'Calificación',
  advance: 'Avance',
  plan_id: 'ID de Plan',
  progress: 'Progreso',
  expired: 'Vencimiento',
  name: 'Nombre',
  action_plans: 'Planes de acción',
  areasOfOpportunity: 'Áreas de Oportunidad',

  // Widget de agenda diaria
  no_events: 'Sin eventos pendientes para hoy.',
  schedule: 'Agenda Diaria',

  // Widget de campañas
  campaign: 'Campañas',

  // Mensajes de transicion del modulo
  toDate: 'Estamos actualizando este modulo. Puedes seguir consultando la informacion en el modulo de Reportes.',
  monthbefore: 'Mes anterior:',

  // Gestion de dashboards (crear, seleccionar, favoritos)
  select_dashboard: 'Seleccione un dashboard',
  create_dashboard: 'Crear Dashboard',
  new_dashboard: 'Nuevo Dashboard',
  new_dashboard_name: 'Nombre del Dashboard:',
  favorite: 'Favorito',
  delete_dashboard_prompt: '¿Desea eliminar este dashboard?',
  favorite_warning: 'Si marca este dashboard como favorito, se cargará automáticamente en su página de inicio.',

  // Confirmacion de cambio de dashboard favorito (dialogo)
  labels: {
    favorite: 'Dashboard Favorito',
    favorite_warning: 'Está a punto de cambiar su Dashboard favorito. ¿Desea continuar?'
  }
}
